import React, { Component } from "react";
import "@ant-design/compatible/assets/index.css";
import { Modal, Table, Button } from "antd";
import { stubCfgRecord } from "@/fetch/fetchApi";
import { TableLocale } from "@/utils/publicParam";

// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

import LogDetail from "./logDetail";

// eslint-disable-next-line arrow-parens
@connect(state => state)
class ModifyLog extends Component {
  constructor(props) {
    super(props);
    this.internationalization = this.props.intl.messages.modifyLog;
    this.state = {
      data: [],
      pagination: {},
      stubId: this.props.stubId,
    };
    this.init();
  }

  init() {
    this.query = {
      page: "1",
      pagecount: "10",
      stubId: this.props.stubId,
    };
    this.stubCfgRecord();
    this.addTable();
  }

  addTable() {
    this.tableColumns = [
      {
        title: this.internationalization.actionSheet, // '操作类型',
        dataIndex: "operationType",
        key: "operationType",
        className: "column-nowrap",
        render: (text) => {
          if (text === "UPDATE") {
            return this.internationalization.btn1;
          }
          if (text === "SYNC") {
            return this.internationalization.btn2;
          }
          if (text === "GET") {
            return "获取最新配置";
          }
          if (text === "REPORT") {
            return "上报";
          }
        },
      },
      {
        title: this.internationalization.title1, // '操作方式',
        dataIndex: "operationFrom",
        key: "operationFrom",
        align: "center",
        render: (text) => {
          if (text === "ONLINE") {
            return this.internationalization.title2;
          }
          if (text === "OFFLINE") {
            return this.internationalization.title3;
          }
        },
      },
      {
        title: this.internationalization.title4, // '操作平台',
        dataIndex: "platform",
        key: "platform",
        align: "center",
      },
      {
        title: this.internationalization.title5, // '操作人',
        dataIndex: "username",
        key: "username",
      },
      {
        title: this.internationalization.title6, // '操作时间',
        dataIndex: "createTime",
        key: "createTime",
        align: "center",
      },
      {
        title: "操作结果",
        dataIndex: "status",
        key: "status",
        align: "center",
        render: (text) => {
          switch (text) {
            case 0:
              return "失败";
            case 1:
              return "成功";
            case 2:
              return "等待上报";
            case 3:
              return "超时";
            default:
              return "--";
          }
        },
      },
      {
        title: this.internationalization.btn3, // '变更参数',
        dataIndex: "operation",
        key: "operation",
        align: "center",
        render: (text, record) => (
          <Button
            disabled={record.operationType === "GET"}
            type="link"
            onClick={(e) => this.showDetailModal(e, record)}>
            {this.internationalization.btn4}
          </Button>
        ),
      },
    ];
  }

  showDetailModal = (e, record) => {
    e.preventDefault();
    console.kun(record);
    this.setState({
      visible: true,
      detailRecord: record,
    });
  };

  stubCfgRecord = () => {
    this.setState({
      loading: true,
    });
    stubCfgRecord(this.query).then((res) => {
      if (res.data.code === "200") {
        const pagination = this.state.pagination;
        pagination.total = res.data.pageLimit.totalCount;
        pagination.current = parseInt(this.query.page, 10);
        this.setState({
          loading: false,
          data: res.data.data,
          pagination,
        });
      }
    });
  };

  componentDidMount() {
    // this.init();
  }

  //
  componentWillReceiveProps() {
    this.init(); // 每次进入变更记录都要进行刷新
  }

  handleTableChange = (pagination) => {
    this.query.page = pagination.current;
    this.stubCfgRecord();
  };

  handleCancel = () => {
    this.setState({
      visible: false,
    });
  };

  render() {
    const content = (
      <div className="sc-page-content">
        <div className="page-panel">
          <Table
            onChange={this.handleTableChange}
            bordered
            dataSource={this.state.data}
            loading={this.state.loading}
            columns={this.tableColumns}
            pagination={this.state.pagination}
            scroll={{ x: 952 }}
            locale={TableLocale}
            //    footer={this.state.data && this.state.data.length ? () => <div></div> : null}
            className="sc-table"
          />
        </div>
        <Modal
          width="800px"
          visible={this.state.visible}
          footer={null}
          onCancel={this.handleCancel}
          title={this.internationalization.btn3}>
          <LogDetail data={this.state.detailRecord} />
        </Modal>
      </div>
    );
    return content;
  }
}

export default injectIntl(ModifyLog);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/modifyLog.js